import useTranslation from '../../../../Hooks/useTranslation';
import {
	ToothFurcation,
	ToothMobility,
	ToothPeriodontal,
} from '../../../../graphql/graphql';

type SimplePeriodontal = Pick<ToothPeriodontal, 'mobility' | 'furcation'>;
type SimplePeriodontalKey = keyof SimplePeriodontal;
type SimplePeriodontalValue = NonNullable<
	SimplePeriodontal[SimplePeriodontalKey]
>;

const SIMPLE_PERIODONTAL_KEY_MAP: Record<SimplePeriodontalKey, string> = {
	mobility: 'patientTreatment.meddiDENT.dentalCross.mobility.title',
	furcation: 'patientTreatment.meddiDENT.dentalCross.furcation.title',
};

const SIMPLE_PERIODONTAL_VALUE_MAP: Record<SimplePeriodontalValue, string> = {
	[ToothMobility.None]: 'base.none',
	[ToothMobility.Class_1]:
		'patientTreatment.meddiDENT.dentalCross.mobility.class1',
	[ToothMobility.Class_2]:
		'patientTreatment.meddiDENT.dentalCross.mobility.class2',
	[ToothMobility.Class_3]:
		'patientTreatment.meddiDENT.dentalCross.mobility.class3',
	[ToothFurcation.Stage_1]:
		'patientTreatment.meddiDENT.dentalCross.furcation.stage1',
	[ToothFurcation.Stage_2]:
		'patientTreatment.meddiDENT.dentalCross.furcation.stage2',
	[ToothFurcation.Stage_3]:
		'patientTreatment.meddiDENT.dentalCross.furcation.stage3',
};

export default function parseSimplePeriodontalValue<
	T extends SimplePeriodontalKey,
>(key: T, value: SimplePeriodontalValue) {
	const { t } = useTranslation();

	return `${t(SIMPLE_PERIODONTAL_KEY_MAP[key])} - ${t(
		SIMPLE_PERIODONTAL_VALUE_MAP[value],
	)}`;
}
